"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var payment_methods_controller_1 = __importDefault(require("./payment-methods.controller"));
var payment_methods_html_1 = __importDefault(require("./payment-methods.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.paymentmethods", {
        url: "/payment-methods",
        controller: payment_methods_controller_1.default,
        controllerAs: "vm",
        template: payment_methods_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.paymentmethods", [])
    .config(config)
    .controller("StudentPaymentMethodsController", payment_methods_controller_1.default);
